<template>
  <div class="create">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>{{ rowId ? '官网文字编辑' : '官网文字创建' }}</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/webofficial')"
          >返回</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <el-form
        :model="formData"
        :rules="rules"
        label-width="130px"
        ref="formData"
      >
        <el-form-item label="类型" prop="type">
          <el-select
            :disabled="isEdit"
            v-model="formData.type"
            placeholder="请选择类型"
            clearable
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="parseInt(item.value)"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input clearable v-model="formData.title"> </el-input>
        </el-form-item>
        <!-- <el-form-item label="内容" prop="content" v-if="formData.type == 11">
          <MyEditor ref="editor" key="i" v-model="formData.content" />
        </el-form-item> -->
        <el-form-item label="内容" prop="content">
          <el-input clearable v-model="formData.content" type="textarea">
          </el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input clearable v-model="formData.sort" type="number"> </el-input>
        </el-form-item>

        <el-form-item label="图片" prop="imagePath">
          <imageUpload
            v-model="formData.imagePath"
            :isShowTip="false"
            :limit="3"
          />
          <!-- <el-upload
            class="avatar-uploader"
            action="#"
            multiple
            accept=".jpeg,.png,.jpg"
            list-type="picture-card"
            :http-request="photoUpload"
            :on-change="photoChange"
            :on-remove="photoRemove"
            :on-exceed="photoExceed"
            :before-upload="checkFileType"
            :limit="1"
            :file-list="photoList"
            :class="{ hide: this.photoList.length >= 1 }"
          >
            <i slot="default" class="el-icon-plus" />
          </el-upload> -->
        </el-form-item>

        <!-- <el-form-item label="类型" prop="type">
          <el-radio-group v-model="formData.type" size="small">
            <el-radio :label="1" border>轮播图</el-radio>
            <el-radio :label="2" border>logo</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <!-- <el-form-item label="是否推送公众号" prop="pushMp">
          <el-radio-group v-model="formData.pushMp" size="small">
            <el-radio :label="1" border>是</el-radio>
            <el-radio :label="2" border>否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="是否启用公众号" prop="pushMpFlag">
          <el-radio-group v-model="formData.pushMpFlag" size="small">
            <el-radio :label="1" border>是</el-radio>
            <el-radio :label="2" border>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否推官网" prop="pushOfficialWebsite">
          <el-radio-group v-model="formData.pushOfficialWebsite" size="small">
            <el-radio :label="1" border>是</el-radio>
            <el-radio :label="2" border>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否启用官网" prop="pushOfficialWebsiteFlag">
          <el-radio-group
            v-model="formData.pushOfficialWebsiteFlag"
            size="small"
          >
            <el-radio :label="1" border>是</el-radio>
            <el-radio :label="2" border>否</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="备注" prop="remark">
          <el-input clearable v-model="formData.remark" type="textarea">
          </el-input>
        </el-form-item>
        <div
          class="button-group"
          style="display: flex; justify-content: center"
        >
          <el-button
            type="primary"
            style="width: 185px; margin: 0 20px"
            class="form-button"
            @click="submitFn"
          >
            <span>保存</span>
          </el-button>
          <el-button
            style="width: 185px; margin: 0 20px"
            class="form-button"
            @click="reset"
          >
            <!-- <i v-if="item.icon" :class="item.icon"></i> -->
            <span>重置</span>
          </el-button>
        </div>
      </el-form>
      <!-- <tz-form
        width="130px"
        :formConfig="formConfig"
        :formBtns="formBtns"
        @submit="submitFn"
        @cleanFn="resultClean"
      ></tz-form> -->
      <!-- card content -->
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
import { addList, getId, updateList } from '@/api/webofficial'
import { uploadFile } from '@/api/advertising'
// import MyEditor from './components/MyEditor.vue'

// import { scriptList } from '@/api/scriptis'
// import { queryEquipment } from '@/api/dictionary'

export default {
  // components: {
  //   MyEditor
  // },
  data() {
    return {
      resultSelect: true,
      formData: {},
      itemList: [],
      photoList: [],
      isEdit: false,
      rowId: null,
      typeOptions: [
        {
          value: 1,
          label: '公司口号'
        },
        {
          value: 2,
          label: '服务类型'
        },
        {
          value: 3,
          label: '产品服务标题'
        },
        {
          value: 4,
          label: '产品服务介绍'
        },
        {
          value: 5,
          label: '公司简介'
        },
        {
          value: 6,
          label: '我们的团队'
        },
        // {
        //   value: 7,
        //   label: '经典案例'
        // },
        {
          value: 8,
          label: '我们的成绩'
        },
        {
          value: 9,
          label: '数字成绩'
        },
        {
          value: 10,
          label: '企业愿景'
        },
        {
          value: 11,
          label: '天宙学堂'
        }
      ],
      rules: {
        // title: [{ required: true, message: '标题必填', trigger: 'blur' }],
        // type: [{ required: true, message: '类型必填', trigger: 'blur' }],
        // content: [{ required: true, message: '内容必填', trigger: 'blur' }]
      }
    }
  },

  mounted() {
    let rowId = this.$route.query.id
    let rowType = this.$route.query.type
    if (rowId && rowId != 'null') {
      this.rowId = rowId
      this.handleUpdate(this.rowId)
    } else {
      this.reset()

      if (rowType && rowType != 'null') {
        this.formData.type = Number(rowType)
        this.isEdit = true
      }
    }
  },
  methods: {
    /** 修改按钮操作 */
    handleUpdate(row) {
      // let deviceRow = []
      // let deviceIds = []
      this.reset()
      // const id = row.id || this.ids
      getId({ id: row }).then((response) => {
        let formData = response.data
        // deviceIds.push(row.deviceId)
        // deviceRow.push({ id: row.deviceId, propertyNum: row.propertyNum })
        // this.form.deviceIds = deviceRow
        // this.open = true
        // this.title = '修改设备检测记录'
        // if (
        //   formData.type !== '' &&
        //   formData.type !== null &&
        //   formData.type !== undefined
        // ) {
        //   formData.type = Number(formData.type)
        // }
        if (formData.imagePath) {
          this.photoList.push({
            url: this.getImgUrl(formData.imagePath)
          })
        }
        this.formData = formData
        console.log(this.photoList)
      })
    },
    // 监听radio框变化
    handleClick(val) {
      this.formData.resultValue = ''
      console.log(val)
      if (val === 1) {
        this.resultSelect = true
      } else if (val === 2) {
        this.resultSelect = false
      }
    },
    // 重置
    clearFn() {
      this.resultSelect = true
      this.$refs['formData'].resetFields()
    },
    // 表单重置
    reset() {
      this.formData = {
        id: null,
        title: null,
        remark: null,
        imagePath: null,
        type: 1,
        content: null,
        sort: null
        //         type所对应的值
        // 1.
        // 首页的公司服务类型标题 （1-2）
        // 2.
        // 首页的公司服务类型内容介绍（1-2）
        // 3.
        // 首页的产品服务标题；（1-3）
        // 4.
        // 首页的产品服务介绍；（1-3）
        // 5.
        // 首页的公司简介；（1-4）
        // 6.
        // 首页的我们的团对；（1-5）
        // 7.
        // 首页的经典案例；（1-6）
        // 8.
        // 关于我们页面的发展历程（2-4）
        // pushMp: 1, //推送公众号
        // pushMpFlag: 1, //公众号是否启用
        // pushOfficialWebsite: 1, //是否推官网
        // pushOfficialWebsiteFlag: 1 //官网是否启用
      }
      this.$refs['formData'].resetFields()
    },
    // 上传照片
    photoUpload() {
      this.formData.imagePath = ''
      const formData = new FormData()
      this.photoList.forEach((el) => {
        console.log(el)
        formData.append('multipartFile', el.raw)
      })
      this.$loading({
        text: '图片上传中'
      })
      uploadFile(formData).then((res) => {
        console.log(res.data, '创建')
        if (res.code == 200) {
          this.formData.imagePath = res.data.uploadUrl
          this.$message({
            message: '上传成功',
            type: 'success'
          })
          this.$loading().close()
        } else {
          this.formData.imagePath = ''
          this.$message({
            message: '上传失败',
            type: 'success'
          })
          this.photoList = []
          this.$loading().close()
        }
      })
    },
    //移除头像
    photoRemove(file, fileList) {
      this.photoList = fileList
      this.formData.imagePath = ''
    },
    // 照片类型限制
    checkFileType(file) {
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.'))
      // jpeg,.png,.jpg,.bmp,.gif
      if (fileType === '.jpg' || fileType === '.png' || fileType === '.jpeg') {
        // 不处理
        console.log('格式正确')
      } else {
        this.$message.error('不是.jpeg,.png,.jpg文件,请上传正确的图片类型')
        return false
      }
    },

    //头像超限制
    photoExceed(files, fileList) {
      console.log(files, fileList)

      this.$message.error(`只允许一次性上传1张图片`)
    },
    photoChange(file, fileList) {
      console.log(this.fileList, 'change')

      this.photoList = fileList
      //获取上传文件大小
      let imgSize = Number(file.size / 1024 / 1024)
      if (imgSize > 1000) {
        this.$msgbox({
          title: '',
          message: '文件大小不能超过1000MB，请重新上传。',
          type: 'warning'
        })
        this.photoList = []
        return
      }
      this.photoList = fileList
    },
    // 提交
    submitFn() {
      console.log(this.formData, '报告创建')
      this.$refs.formData.validate((isSuccess) => {
        if (isSuccess) {
          if (this.submited) return
          // this.$loading({
          //   text: '报告添加中'
          // })

          if (this.formData.id == null) {
            addList(this.formData).then((res) => {
              console.log(res.data, '创建')
              if (res.code == 200) {
                this.submited = true
                this.$message({
                  message: '添加成功',
                  type: 'success'
                })
                this.$router.go(-1)
              } else {
                this.$message({
                  message: res.data,
                  type: 'error'
                })
              }
            })
            this.$loading().close()
          } else {
            updateList(this.formData).then((res) => {
              console.log(res.data, '创建')
              if (res.code == 200) {
                this.submited = true
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                this.$router.go(-1)
              } else {
                this.$message({
                  message: res.data,
                  type: 'error'
                })
              }
            })
            this.$loading().close()
          }
        } else {
          this.$message({
            message: '请输入必填项',
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
// .el-upload--picture-card 控制加号部分
::v-deep.hide .el-upload--picture-card {
  display: none;
}
</style>
